import { i18n } from '@/i18n';

// Functions, so the text follows the language active when each step is shown
export const startText = () => i18n.t('tour.start');
export const backText = () => i18n.t('tour.back');
export const forwardText = () => i18n.t('tour.next');
export const finishText = () => i18n.t('tour.finish');

export const defaultTourSettings = {
    tourName: 'dashboard',
    useModalOverlay: true,
    exitOnEsc: false,
    defaultStepOptions: {
        scrollTo: true,
    },
};

export function defaultStepSettings(shepherdTour) {
    return {
        arrow: true,
        classes: 'shepherd-dialog',
        buttons: [
            {
                classes: 'myprovet-shepherd-btn-back',
                text: backText,
                action: shepherdTour.back,
            },
            {
                classes: 'myprovet-shepherd-btn-next',
                text: forwardText,
                action: shepherdTour.next,
            },
        ],
    };
}
